import { render } from "./tgbAvatar.vue?vue&type=template&id=2600c8bf"
import script from "./tgbAvatar.vue?vue&type=script&lang=js"
export * from "./tgbAvatar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__